export default __webpack_public_path__ + "static/media/drag_move.434f790d.svg";